var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCameraRotate = function SvgIconCameraRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.641 9.013a4.76 4.76 0 0 1 6.718 0l.014.015.093.096.048-.288a1 1 0 1 1 1.972.328l-.375 2.25a1 1 0 0 1-.822.822l-2.25.375a1 1 0 1 1-.328-1.972l.376-.063-.146-.152a2.76 2.76 0 0 0-3.888.006A1 1 0 1 1 8.64 9.013M11.111 12.96a1 1 0 0 1-.822 1.151l-.376.063.146.152a2.76 2.76 0 0 0 3.888-.006 1 1 0 0 1 1.412 1.417 4.76 4.76 0 0 1-6.718 0l-.014-.015-.093-.096-.048.288a1 1 0 1 1-1.972-.328l.375-2.25a1 1 0 0 1 .822-.822l2.25-.375a1 1 0 0 1 1.15.822"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.168 3.195A1 1 0 0 1 9 2.75h6a1 1 0 0 1 .832.445L17.035 5H19.5A2.5 2.5 0 0 1 22 7.5V18a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18V7.5A2.5 2.5 0 0 1 4.5 5h2.465zM9.535 4.75 8.332 6.555A1 1 0 0 1 7.5 7h-3a.5.5 0 0 0-.5.5V18a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V7.5a.5.5 0 0 0-.5-.5h-3a1 1 0 0 1-.832-.445L14.465 4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCameraRotate;